import cx from 'classnames'
import React from 'react'

import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Link from '../Link/Link'
import styles from './dropdownLinks-style.css'
import HighlightCard from '@/components/HighlightCard/HighlightCard'
import { HighlightCardViewModel } from '@/view-models/HighlightCardViewModel'

type Props = {
  items?: Array<LinkViewModel>
  downLink?: LinkViewModel
  cardLinks?: Array<HighlightCardViewModel>
  className?: string
  eventName?: string
  text?: string
}

const DropdownLinks: React.FC<Props> = ({ items, downLink, cardLinks, className, eventName, text }) => {
  if (!items) {
    return null
  }

  const renderItem = (item: LinkViewModel) => {
    const eventMeta =
      eventName === 'login'
        ? {
          event: 'login',
          eventData: item.label,
        }
        : {}

    return (
      <li key={item.href} className={styles.item}>
        <Link
          {...item}
          noUnderline
          hoverArrow
          className={cx(styles.itemLink, {
            [styles.itemLinkActive]: item.active,
          })}
        >
          {item.label}
        </Link>
      </li>
    )
  }

  return (
    <ul className={cx(styles.dropdownLinks, className)}>
      <div className={styles.dropdownLinksContainerWrapper}>
        <div className={styles.dropdownLinksContainer}>
          {text && <div className={styles.text}>{text}</div>}
          {items.map(renderItem)}
        </div>
        <div className={styles.dropdownLinksContainerInnerWrapper}>
          {cardLinks && cardLinks.map((cardLink) => <HighlightCard key={cardLink.id} item={cardLink} />)}
        </div>
      </div>
      {downLink && (
        <Link {...downLink} className={styles.downLink} hoverArrow secondary>
          {downLink.label}
        </Link>
      )}
    </ul>
  )
}

export default DropdownLinks